import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import cn from 'classnames';
import { useFormField } from '@awardit/formaggio';
import { Input, Checkbox, Foldable, SearchableDropdown, DropdownItem } from '@crossroads/ui-components';
import { useTranslate } from '@awardit/react-use-translate';
import styles from 'shop-views/Field.scss';

var _excluded = ["alwaysValidate"],
    _excluded2 = ["children", "className", "name"],
    _excluded3 = ["alwaysValidate", "items", "label", "disabled"];
var Field = _ref => {
  var _ref$alwaysValidate = _ref.alwaysValidate,
      alwaysValidate = _ref$alwaysValidate === void 0 ? false : _ref$alwaysValidate,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var t = useTranslate();

  var _useFormField = useFormField(props.name, ""),
      submitted = _useFormField.submitted,
      dirty = _useFormField.dirty,
      errors = _useFormField.errors,
      inputProps = _useFormField.inputProps;

  var inputErrors = submitted || dirty || alwaysValidate === true ? errors.map(x => t(`VALIDATION.${x.error}`)) : [];
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, inputProps, {
    errors: inputErrors
  }));
};
var CheckboxField = _ref2 => {
  var children = _ref2.children,
      className = _ref2.className,
      name = _ref2.name,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var t = useTranslate();
  var fieldProps = useFormField(name, "");
  var inputErrors = fieldProps.submitted || fieldProps.dirty ? fieldProps.errors.map(x => t(`VALIDATION.${x.error}`)) : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, fieldProps.inputProps, {
    className: cn(styles.checkbox, className),
    CheckedComponent: cn[styles.checkboxIcon],
    value: fieldProps.inputProps.value,
    name: name
  }), children)), /*#__PURE__*/React.createElement(Foldable, {
    className: styles.errors,
    open: inputErrors.length > 0
  }, inputErrors.map(x => /*#__PURE__*/React.createElement("span", {
    key: x
  }, x))));
};
var SearchableDropdownField = _ref3 => {
  var _ref3$alwaysValidate = _ref3.alwaysValidate,
      alwaysValidate = _ref3$alwaysValidate === void 0 ? false : _ref3$alwaysValidate,
      items = _ref3.items,
      label = _ref3.label,
      disabled = _ref3.disabled,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  var t = useTranslate();

  var _useFormField2 = useFormField(props.name, ""),
      submitted = _useFormField2.submitted,
      dirty = _useFormField2.dirty,
      errors = _useFormField2.errors,
      inputProps = _useFormField2.inputProps;

  var inputErrors = submitted || dirty || alwaysValidate === true ? errors.map(x => t(`VALIDATION.${x.error}`)) : [];
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.searchableDropdown, {
      [styles.disabled]: disabled
    })
  }, /*#__PURE__*/React.createElement(SearchableDropdown, _extends({}, props, inputProps, {
    value: inputProps.value.toString(),
    errors: inputErrors,
    disabled: disabled,
    onChange: x => inputProps.onChange({
      target: {
        value: x
      }
    })
  }), items.map(c => /*#__PURE__*/React.createElement(DropdownItem, {
    key: c.code,
    value: c.code
  }, c.name))), label && /*#__PURE__*/React.createElement("label", {
    className: cn(styles.searchableDropdownLabel, {
      [styles.searchableDropdownLabel__active]: inputProps.value.toString().length > 0
    })
  }, label));
};

export { CheckboxField, Field, SearchableDropdownField };
//# sourceMappingURL=index.js.map
